<template>
  <b-card class="complete-profile text-center">
    <h6><strong>Complete your profile</strong></h6>
    <b-img src="@/assets/images/profile1.png" alt="Profile" width="66" class="m-2" />
    <div class="mb-3">
      <div class="font-size-sm m-2">
        Your profile is not complete yet.
      </div>
      <div class="font-size-sm m-2">
        Take a minute to fill informations.
      </div>
    </div>
    <template #footer>
      <div class="mb-2">
        <b-link :to="{name: 'UserProfile', params: { userId: profile.id }}">Go to profile</b-link>
      </div>
    </template>
  </b-card>
</template>

<script>
export default {
  name: 'CompleteProfile',

  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
